import { render, staticRenderFns } from "./attribute-drawer.vue?vue&type=template&id=d1572cae&scoped=true&"
import script from "./attribute-drawer.vue?vue&type=script&lang=ts&"
export * from "./attribute-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./attribute-drawer.vue?vue&type=style&index=0&id=d1572cae&prod&lang=less&scoped=true&"
import style1 from "./attribute-drawer.vue?vue&type=style&index=1&id=d1572cae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1572cae",
  null
  
)

export default component.exports